

          
          
          window.Fandango.templates = window.Fandango.templates || {};
          window.Fandango.templates._noTheatersError = function anonymous(_swig,_ctx,_filters,_utils,_fn
) {
  var _imports = {  };
  var _ext = _swig.extensions,
    _output = "";
if ((((typeof _ctx.openFilterEnabled !== "undefined" && _ctx.openFilterEnabled !== null) ? ((typeof _ctx.openFilterEnabled !== "undefined" && _ctx.openFilterEnabled !== null) ? _ctx.openFilterEnabled : "") : ((typeof openFilterEnabled !== "undefined" && openFilterEnabled !== null) ? openFilterEnabled : "")) !== null ? ((typeof _ctx.openFilterEnabled !== "undefined" && _ctx.openFilterEnabled !== null) ? ((typeof _ctx.openFilterEnabled !== "undefined" && _ctx.openFilterEnabled !== null) ? _ctx.openFilterEnabled : "") : ((typeof openFilterEnabled !== "undefined" && openFilterEnabled !== null) ? openFilterEnabled : "")) : "" )) { 
_output += "\n    <div class=\"tsp__no-theaters-wrapper\">\n        <img class=\"tsp__no-theaters-img\" src=\"/images/shared/theater-safety-illustration--grayscale.png\" alt=\"theater illustration\">\n        <p class=\"tsp__no-theaters-msg--top dark__text\">We can’t find any theaters with showtimes that fit your selection.</p>\n        <p class=\"tsp__no-theaters-msg--bottom dark__text\">Try adjusting filters, location, or date to find more theaters with showtimes.</p>\n    </div>\n";
} else {
_output += "\n    <strong class=\"dark__text\">We can’t find any theaters with showtimes that fit your selection.</strong>\n    <br />\n    <div class=\"dark__text\">Try adjusting filters, location, or date to find more theaters with showtimes.</div>\n";

}_output += "\n";

  return _output;

}
          export default window.Fandango.templates._noTheatersError;
          